import React from 'react'
import ArticleUkr from './articleUkr'
import ArticleEng from './articleEng'

class History extends React.Component {
  constructor() {
    super()
    this.state = {tabIndex: 0}
  }

  isTabActive({tabIndex}) {
    return 'history__tabs__button' + (this.state.tabIndex === tabIndex ? ' active' : '')
  }

  render() {
    return (
      <div>
        <div className="mp__history">
          <div className="wd">
            <img src="/img/il_3.png" alt="" className="mp__history__ill" />
            <div className="mp__sec__content mp__history__top__content">
              <h2>Кінотеатр з Історією</h2>
              <div className="mp__sec__content__texts">
                  <p>Кінотеатр «Жовтень» розпочав роботу в 1931 році під назвою «Дев'яте Держкіно» за адресою: вул. Констянтинівська, 26, м. Київ (Україна), станція метро «Контрактова площа». Будівля кінотеатру виконана в стилі конструктивізм,  що був дуже популярним у 1920—1930 рр. XX ст.</p>
              </div>
              <a href="/" className="mp__sec__content__button" style={{visibility: "hidden"}}>Детальніше</a>
            </div>
            <div className="mp__sec__content">
              <img src="/img/il_matter.png" alt="" className="mp__history__fest__ill" />
              <div className="mp__sec__content__texts">
                  <p>«Жовтень» — учасник програм Міжнародної асоціації кінотеатрів Europa Cinemas. Асоціація зосереджує свою діяльність на просуванні європейської кінопродукції шляхом підтримки кінотеатрів.</p>
              </div>
            </div>
            <div className="mp__history__road__outer"></div>
            <div className="mp__history__road__inner"></div>
          </div>
        </div>

        {/* Підготовлений розділ історія. Закоментований, тому, що не було команди включати */}
        
        <div className="wd mb-40">

          <div role="tablist" className="history__tabs">
           <h3 role="presentation" className={this.isTabActive({tabIndex: 0})} onClick={() => this.setState({tabIndex: 0})}>УКР</h3>
           <h3 role="presentation" className={this.isTabActive({tabIndex: 1})} onClick={() => this.setState({tabIndex: 1})}>ENG</h3>
          </div>

          <section className="tab-content">
            {this.state.tabIndex === 0 && <ArticleUkr/>}
            {this.state.tabIndex === 1 && <ArticleEng/>}
          </section>

        </div>
     

      </div>
    )
  }
}

export default History


// WEBPACK FOOTER //
// ./src/components/pages/HistoryPage/history.jsx